export default __webpack_public_path__ + "static/Construction-hero-05d19366faaa9ce2b37c622cca27a8ff.png";